import { getLanguage } from 'helpers/utils';

const lang = getLanguage();

export const TERMS_OF_USE = `https://legal.yoga-go.io/page/terms-of-use?language=${lang}`;
export const REFUND_POLICY = `https://legal.yoga-go.io/page/refund-policy?language=${lang}`;
export const PRIVACY_POLICY = `https://legal.yoga-go.io/page/privacy-policy?language=${lang}`;
